export default __webpack_public_path__ + "static/media/footer.d025f458.jpg";